import React from 'react';
import {
  useIsDevCycleInitialized,
  useVariableValue,
  withDevCycleProvider
} from '@devcycle/react-client-sdk';
import { FeatureFlagsProvider } from './feature-flags.context';

const DEV_CYCLE_SDK_KEY = process.env.GATSBY_DEVCYCLE_CLIENT_SDK_KEY?.trim();
const AGENT_UI_VARIABLE_KEY = 'ai-agent-ui-enabled';

const FeatureFlagBoundary = ({ children }) => {
  const isDevCycleInitialized = useIsDevCycleInitialized();
  const isAgentUiEnabled = useVariableValue(AGENT_UI_VARIABLE_KEY, false);
  const resolvedAgentUiEnabled = isDevCycleInitialized && isAgentUiEnabled;

  if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
    window.__AIM360_DEV_FLAGS__ = {
      devCycleSdkKeyPresent: Boolean(DEV_CYCLE_SDK_KEY),
      isDevCycleInitialized,
      isAgentUiEnabled,
      resolvedAgentUiEnabled
    };
  }

  return (
    <FeatureFlagsProvider value={{ isAgentUiEnabled: resolvedAgentUiEnabled }}>
      {children}
    </FeatureFlagsProvider>
  );
};

const DevCycleRootBase = ({ children }) => {
  return <FeatureFlagBoundary>{children}</FeatureFlagBoundary>;
};

const DevCycleWrappedRoot = DEV_CYCLE_SDK_KEY
  ? withDevCycleProvider({
      sdkKey: DEV_CYCLE_SDK_KEY,
      user: {
        isAnonymous: true
      }
    })(DevCycleRootBase)
  : null;

const DevCycleRoot = ({ children }) => {
  if (!DevCycleWrappedRoot) {
    return <FeatureFlagsProvider>{children}</FeatureFlagsProvider>;
  }

  return <DevCycleWrappedRoot>{children}</DevCycleWrappedRoot>;
};

export default DevCycleRoot;
